import React from 'react';
import { Box, Typography } from '@mui/material';
import { Question } from '../../../types/questionnaire';

interface BaseQuestionViewProps {
  question: Question;
  children: React.ReactNode;
}

export const BaseQuestionView: React.FC<BaseQuestionViewProps> = ({ question, children }) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body2" color="text.secondary">
        {question.caption}
        {question.tooltip && ` — ${question.tooltip}`}
      </Typography>
      {children}
      {question.note && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
          {question.note}
        </Typography>
      )}
    </Box>
  );
};
